// extracted by mini-css-extract-plugin
export default {"bottom":"login_bottom__SfQzp","mainDiv":"login_mainDiv__OJw7A","leftDiv":"login_leftDiv__-qmK9","rightDiv":"login_rightDiv__90Fok"};